"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var CallMic = function CallMic(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.05,13.5h.29a3.85,3.85,0,0,0,3.87-3.85h0V3.88A3.88,3.88,0,0,0,10.31,0h-.26A3.9,3.9,0,0,0,6.17,3.88V9.64A3.88,3.88,0,0,0,10.05,13.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.48,9.38a1,1,0,0,0-1,.88,5.63,5.63,0,0,1-10.88,0,1,1,0,0,0-1-.77H3.35a1,1,0,0,0-.74,1,1,1,0,0,0,0,.25v.06a7.64,7.64,0,0,0,6.52,5.63V19a1,1,0,0,0,2,0V16.41a7.62,7.62,0,0,0,6.19-5.65.75.75,0,0,0,.07-.36A1,1,0,0,0,16.48,9.38Z"
  }));
};
var _default = exports["default"] = CallMic;